import React from "react";
import styled from "styled-components";
import {
  border,
  BorderProps,
  color,
  display,
  DisplayProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
} from "styled-system";

interface Props {
  bg?: string;
  backgroundColor?: string;
  opacity?: number;
}

const LineWrapper = styled.hr<
  Props & BorderProps & LayoutProps & SpaceProps & DisplayProps
>`
  ${border}
  ${display}
  ${layout}
  ${color}
  ${space}
  opacity: ${props => props.opacity};
`;

export const Line: React.FC<
  Props & BorderProps & LayoutProps & SpaceProps & DisplayProps
> = props => <LineWrapper {...props} />;

Line.defaultProps = {
  opacity: 0.2,
  height: 1,
  bg: "disabled",
  border: "none",
  display: "unset",
};
